"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("../utils/styled"));
// This is a span because it goes _inside_ a <label>
exports.LabelText = styled_1.default("span")(({ theme }) => ({
    fontSize: theme.font.size.fineprint,
    display: "block",
    verticalAlign: "middle",
    marginBottom: theme.space.base,
    fontWeight: theme.font.weight.bold,
    color: theme.color.text.lightest,
    height: exports.labelTextHeight,
    lineHeight: theme.font.lineHeight,
    userSelect: "none",
}));
exports.labelTextHeight = 15;
exports.default = exports.LabelText;
//# sourceMappingURL=LabelText.js.map